import styled from 'styled-components';

export const StyledFooter = styled.footer`
  width: 100%;
  padding: 48px 0;
  background: #020b1e;
  .container {
    max-width: 1216px;
    margin: auto;
    padding: unset;
    .copyright {
      text-align: center;
      margin-top: 16px;
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
      letter-spacing: 0.0125em;
      color: #8a94a6;
      @media (max-width: 1024px) {
        font-size: 12px;
      }
    }
    .calo-info {
      .logo {
        width: 230px;
        @media (max-width: 1024px) {
          width: 200px;
        }
      }
    }

    .company-info {
      margin-top: 24px;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0.01em;
      color: #8a94a6;
      @media (max-width: 1024px) {
        font-size: 12px;
      }
      div:not(:last-child) {
        margin-bottom: 2px;
      }
      a {
        color: #8a94a6;
      }
    }

    .footer-menu {
      list-style: none;
      padding: 16px 0;
      .footer-link {
        padding-bottom: 24px;
        a {
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          letter-spacing: 0.01em;
          color: #fcfcfc;
          transition: all ease 0.4s;
          &:hover {
            color: #fd7d74;
          }
          @media (max-width: 1024px) {
            font-size: 12px;
          }
        }
        &:last-child {
          padding-right: 0;
          padding-bottom: 0;
        }
      }
    }

    @media (max-width: 1024px) {
      .calo-info {
        .copyright {
          margin-top: 13px;
          color: #8a94a6;
          font-size: 20px;
          line-height: 20px;
        }
      }
    }

    .data-provided {
      .text {
        font-weight: 700;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0.01em;
        color: #8a94a6;
      }
      a {
        display: block;
        width: 165px;
        margin-bottom: 16px;
        @media (max-width: 1024px) {
          width: 135px;
        }
      }
    }
    .btn-download {
      cursor: pointer;
      padding: 16px 13.5px;
      border-radius: 20px;
      position: relative;
      &::before {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: 20px;
        padding: 2px;
        background: linear-gradient(180deg, #ff5122 -25.42%, #ff2d33 100%);
        -webkit-mask: linear-gradient(#fff 0 0) content-box,
          linear-gradient(#fff 0 0);
        -webkit-mask-composite: xor;
      }
      .icon {
        padding-right: 8px;
      }
      .label {
        font-weight: 700;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 1.25px;
        background: linear-gradient(180deg, #ff5122 -25.42%, #ff2d33 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-fill-color: transparent;
      }
      @media (max-width: 1024px) {
        padding: 12px;
        .icon {
          width: 26px;
          padding-right: 6px;
        }
        .label {
          font-size: 10px;
        }
      }
    }
  }
  @media (max-width: 1024px) {
    .container {
      max-width: 980px;
    }
  }
`;
